module.exports = __webpack_public_path__ + "img/game-goToLottery.ff7a18db.png";